import React, { useState, useEffect, useCallback } from 'react';
import guService from '../../services/guService';
import '../Login/index.css';
import logo from '../../assets/logo.svg';
import Swal from "sweetalert2";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faKey, faEyeSlash, faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import {Link, useHistory, useParams} from "react-router-dom";
import {successToast} from "../../components/DommusToast";


export default function AlterarSenha({ history }) {
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const {token} = useParams();
  const browserHistory = useHistory();

  function handleAlterarSubmit() {
    if(password !== passwordConfirmation) {
      setError(true);
      setErrorMessage('As senhas precisam ser iguais!');
      setPasswordConfirmation('');
      return;
    }
    guService.auth.alterarSenha(password, token).then(res => {
      successToast.fire(res.data.message)
      browserHistory.push('/login')
    }).catch(err => {
      Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao tentar recuperar a senha. Tente solicitar um novo link",
          icon: 'error'
      });
    })
  }

  return (<div className="login">
    <div className="imagemLogin">
      <div className="imagemFundoLogin">
        <div className="logo-dommus">
          <img src={logo} alt="Dommus" />
        </div>
      </div>
    </div>
    <div className="container">
      <div className="logo-dommus mobile">
        <img src={logo} alt="Dommus" />
      </div>
      <div className='faca-login'>Recuperação de Senha:</div>
      <div className="content">
        <form onSubmit={handleAlterarSubmit}>

          <label htmlFor="password">Nova Senha</label>
          <input
            type="password"
            id="password"
            placeholder="Nova Senha"
            required="required"
            value={password}
            onChange={event => setPassword(event.target.value)}
          />
          <label htmlFor="password_confirmation">Repita a Senha</label>
          <input
            type="password"
            id="password"
            required="required"
            placeholder="Repita a Senha"
            value={passwordConfirmation}
            onChange={event => setPasswordConfirmation(event.target.value)}
          />

          {error ? <p className="error">{errorMessage}</p> : <></>}

          <div className="buttons">
            <button className="btn btn-submit" onClick={handleAlterarSubmit} type="button">Alterar Senha</button>

          </div>
          <div style={{marginBottom: '20px', textAlign: 'left'}} className="forgot-password">
            <Link to='/login'>
              <FontAwesomeIcon
                data-tip="recuperar senha"
                icon={faChevronLeft}
              /> Voltar para o login
            </Link>
          </div>

        </form>
      </div>

    </div>
  </div>
  )
}
